import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import InfoIcon from '@mui/icons-material/Info';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';

function OfficeIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {

        if (isAuthenticated && tokenIsExpired(token)) {

            logout();
            return;
        }
        fetchtableData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {

        fetchData('ExpenseApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Details:', error);
            });

    };

    const handleDelete = async () => {
        deleteData('ExpenseApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ExpenseApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData();
            })
            .catch((error) => {

            });
    };


    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>EXPENSE</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'left', color: 'white', textTransform: 'uppercase' }}>Sl.no</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'left', color: 'white', textTransform: 'uppercase' }}>E.Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'left', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'right', color: 'white', textTransform: 'uppercase' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>ClaimStatus</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '10px', padding: '4px', textAlign: 'center', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#D5F5E3' }}>

                            {filteredData.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '13px', padding: '3px', fontWeight: 'bolder', color: 'black' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '13px', padding: '3px', fontWeight: 'bolder', color: 'black' }}>
                                        {item.expenseEntryDate && new Date(item.expenseEntryDate).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '13px', padding: '3px', fontWeight: 'bolder', color: 'black' }}>{item.engineerName}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '13px', padding: '3px', fontWeight: 'bolder', color: 'black', textAlign: 'right' }}>{item.amount}</TableCell>
                                    {item.isProccessed && (
                                        <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '15px', padding: '3px', color: '#2e7d32', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'black', textAlign: 'center' }}>{item.proccessed}</TableCell>
                                    )}

                                    {!item.isProccessed && (
                                        <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '15px', padding: '3px', color: 'brown', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'black', textAlign: 'center' }}>{item.proccessed}</TableCell>
                                    )}

                                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ddd', fontSize: '13px', padding: '3px', textAlign: 'center' }}>
                                        <Link to={`/OfficeEditPage/${item.id}`}>
                                            <Tooltip title="Claim Details">
                                                <IconButton style={{ color: 'darkolivegreen' }}>
                                                    <InfoIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default OfficeIndex;

